/** Host element helper: ShadowRoot, style injection, app boot.
 *
 * Fonts: @font-face must live in the light DOM (a ShadowRoot's <style>
 * never loads font binaries the CSS spec's way widgets expect), so it is
 * NOT handled here — see index.ts (standalone entry, imports the font CSS
 * directly) and entry.lib.ts / README.md (lib entry: the host page loads
 * it, since Vite's lib build would otherwise base64-inline every font file
 * into one ~2MB stylesheet). */

import styles from "../styles/index.scss?inline";
import { App } from "../app";
import { applyTheme } from "../lib/i18n";

export function bootHost(host: HTMLElement): App {
  // Dark by default; the header's toggle flips the attribute in place.
  applyTheme(host);
  const shadow = host.shadowRoot ?? host.attachShadow({ mode: "open" });
  shadow.innerHTML = "";

  const style = document.createElement("style");
  style.textContent = styles;
  shadow.appendChild(style);

  const root = document.createElement("div");
  root.className = "app-root";
  shadow.appendChild(root);

  const app = new App(root);
  app.start();
  return app;
}
